import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9ea16f52")

_pushScopeId("data-v-9ea16f52")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("読み込み中...")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("住所を選択してください。 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_loading_message = _resolveComponent("loading-message")
  const _component_radio_button_group_vertical = _resolveComponent("radio-button-group-vertical")
  const _component_vue_content_item_frame = _resolveComponent("vue-content-item-frame")

  return (_openBlock(), _createBlock(_component_vue_content_item_frame, null, {
    default: _withId(() => [
      (_ctx.state.fetchStatus === _ctx.FetchStatus.Failed)
        ? (_openBlock(), _createBlock("div", _hoisted_1, "読み込み失敗(戻るを押して、もう一度試してみてください)"))
        : (_ctx.state.fetchStatus !== _ctx.FetchStatus.Fetched)
          ? (_openBlock(), _createBlock(_component_loading_message, { key: 1 }, {
              default: _withId(() => [
                _hoisted_2
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_radio_button_group_vertical, {
              key: 2,
              "group-id": _ctx.keyValue,
              radios: _ctx.addresses,
              modelValue: _ctx.modelValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSelect($event)))
            }, {
              default: _withId(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["group-id", "radios", "modelValue"]))
    ]),
    _: 1
  }))
})